import React, {useState} from 'react';
import {
    Box,
    Button,
    CircularProgress,
} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import useEffectExceptOnMount from "../../../../helpers/useEffectExceptOnMount";

const FormFooter = ({
    isEditing,
    activeStep,
    steps,
    disableCreate,
    hasError,
    resetError,
    disabledNext,
    disabledSave,
    disabledSaveReason,
    isLastStep,
    onClose,
    handleBack,
    handleNext,
    handleSubmit,
    createLabel = "Create",
    ...props
}) => {
    const [saving, setSaving] = useState(false);

    const onCreate = (event) => {
        setSaving(!!disableCreate);
        handleSubmit(event);
    };

    useEffectExceptOnMount(() => {
        if (disableCreate && saving && hasError) {
            setSaving(false);
            resetError();
        }
    }, [hasError]);

    return (
        <React.Fragment>
            {!isEditing && (
                <Box className={"form-footer"}>
                    {activeStep === 0 ? (
                        <Button variant="outlined" onClick={onClose}>
                            Close
                        </Button>
                    ) : (
                        <Button variant="outlined" onClick={handleBack}>
                            Back
                        </Button>
                    )}
                    {isLastStep ? (
                        <Tooltip title={disabledSaveReason || ""} arrow placement="top">
                            <span>
                                <Button
                                    className="create"
                                    color="primary"
                                    variant="contained"
                                    onClick={onCreate}
                                    disabled={disabledSave || saving}
                                    style={{ position: 'relative' }}
                                >
                                    {saving && (
                                        <CircularProgress style={{ height: '20px', width: '20px', position: 'absolute' }} />
                                    )}
                                    <span style={{ visibility: saving ? 'hidden' : 'visible' }}>
                                        {createLabel}
                                    </span>
                                </Button>
                            </span>
                        </Tooltip>
                    ) : (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleNext}
                            disabled={disabledNext}
                        >
                            Next
                        </Button>
                    )}
                </Box>
            )}
        </React.Fragment>
    );
};

export default FormFooter;
